import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2'
import axiosInstance from '../services/axiosInterceptor'
import {
  fetchDepartments,
  adminListDeptHeads, adminAddDeptHead, adminRemoveDeptHead,
} from './api/issuesApi'

export default function IssueAdminDeptHeads() {
  const [depts, setDepts] = useState([])
  const [heads, setHeads] = useState([])
  const [teachers, setTeachers] = useState([])
  const [loading, setLoading] = useState(true)
  const [form, setForm] = useState({ dept_id: '', t_id: '' })

  const load = async () => {
    setLoading(true)
    try {
      const [d, h, t] = await Promise.all([
        fetchDepartments('staff'),
        adminListDeptHeads(),
        axiosInstance.get('/api/getTeacherList').then(r => r.data).catch(() => []),
      ])
      setDepts(d); setHeads(h); setTeachers(t)
    } finally { setLoading(false) }
  }
  useEffect(() => { load() }, [])

  const add = async (e) => {
    e.preventDefault()
    if (!form.dept_id || !form.t_id) {
      Swal.fire('กรุณาเลือกฝ่ายและบุคลากร', '', 'warning'); return
    }
    try {
      await adminAddDeptHead({ dept_id: Number(form.dept_id), t_id: Number(form.t_id) })
      setForm({ dept_id: '', t_id: '' })
      await load()
    } catch (err) {
      Swal.fire('ผิดพลาด', err.response?.data?.error || err.message, 'error')
    }
  }

  const remove = async (h) => {
    const r = await Swal.fire({
      title: 'ลบหัวหน้าฝ่าย?',
      text: `${h.t_name} จาก ${h.dept_name}`,
      icon: 'warning', showCancelButton: true,
      confirmButtonText: 'ลบ', cancelButtonText: 'ยกเลิก',
    })
    if (!r.isConfirmed) return
    try { await adminRemoveDeptHead(h.dh_id); await load() }
    catch (err) { Swal.fire('ผิดพลาด', err.response?.data?.error || err.message, 'error') }
  }

  // Group by dept for nicer display
  const grouped = depts.map(d => ({
    ...d,
    members: heads.filter(h => h.dept_id === d.dept_id),
  }))

  return (
    <div className="main main-app p-3 p-lg-4">
      <h4 className="mb-3"><i className="ri-team-line me-2" />หัวหน้าฝ่าย (รับเรื่องแจ้งปัญหา)</h4>

      <div className="card mb-3">
        <div className="card-body">
          <form className="row g-2" onSubmit={add}>
            <div className="col-12 col-md-5">
              <label className="form-label small">ฝ่าย</label>
              <select className="form-select" value={form.dept_id}
                      onChange={e => setForm({ ...form, dept_id: e.target.value })}>
                <option value="">-- เลือกฝ่าย --</option>
                {depts.map(d => <option key={d.dept_id} value={d.dept_id}>{d.dept_name}</option>)}
              </select>
            </div>
            <div className="col-12 col-md-5">
              <label className="form-label small">บุคลากร</label>
              <select className="form-select" value={form.t_id}
                      onChange={e => setForm({ ...form, t_id: e.target.value })}>
                <option value="">-- เลือกบุคลากร --</option>
                {teachers.map(t => <option key={t.t_id} value={t.t_id}>{t.t_name}</option>)}
              </select>
            </div>
            <div className="col-12 col-md-2 d-flex align-items-end">
              <button type="submit" className="btn btn-primary w-100">
                <i className="ri-add-line me-1" />เพิ่ม
              </button>
            </div>
          </form>
        </div>
      </div>

      {loading
        ? <div className="text-center py-5"><span className="spinner-border" /></div>
        : (
          <div className="row g-3">
            {grouped.map(g => (
              <div key={g.dept_id} className="col-12 col-md-6 col-lg-4">
                <div className="card h-100">
                  <div className="card-body">
                    <h6 className="card-title mb-3">
                      <i className="ri-building-line me-1" />{g.dept_name}
                    </h6>
                    {g.members.length === 0
                      ? <div className="text-muted small">ยังไม่มีหัวหน้าฝ่าย</div>
                      : (
                        <ul className="list-unstyled mb-0">
                          {g.members.map(m => (
                            <li key={m.dh_id} className="d-flex align-items-center gap-2 py-1">
                              <i className="ri-user-3-line text-primary" />
                              <span className="flex-grow-1 small">{m.t_name}</span>
                              <button className="btn btn-sm btn-link text-danger p-0" onClick={() => remove(m)}>
                                <i className="ri-delete-bin-line" />
                              </button>
                            </li>
                          ))}
                        </ul>
                      )
                    }
                  </div>
                </div>
              </div>
            ))}
          </div>
        )
      }
    </div>
  )
}
